import { FormattedMessage } from 'react-intl';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, LabelL } from '@sorare/core/src/atoms/typography';

import { MarketGuidanceLayout } from 'components/onboarding/MarketGuidanceLayout';
import { RecruitPlayersAnimation } from 'components/onboarding/RecruitPlayersAnimation';

const TutorialRecruitPage = () => {
  return (
    <MarketGuidanceLayout progress={10}>
      <Vertical gap={4} center>
        <Vertical gap={1.5} center>
          <FormattedMessage
            id="TutorialRecruitPage.title"
            defaultMessage="<em>Recruit</em><label>players who will make the difference!</label>"
            values={{
              em: chunks => <BrandL>{chunks}</BrandL>,
              label: chunks => <LabelL>{chunks}</LabelL>,
            }}
          />
        </Vertical>
        <RecruitPlayersAnimation />
      </Vertical>
    </MarketGuidanceLayout>
  );
};
export default TutorialRecruitPage;
